import React from 'react';
import { noop } from 'lodash';

export const AdminActionButtonContext = React.createContext({
  open: noop,
  close: noop,
});
